import { useState, useEffect, useContext } from "react";
import axiosBaseURL from "../../httpCommon";
import BredCrumb from "./BredCrumb";
import InternalBaseBanner from "./InternalBaseBanner";
import { DrtContext } from "../../context/DrtContext";
import { useTitle } from "../../services/PageTitle";
import archiveDate from "../../services/Date";

const Downloads = () => {
  useTitle("Downloads");
  const { EncryptDecrypt } = useContext(DrtContext);
  
  const [listDownloads, setListDownloads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showArchive, setShowArchive] = useState(false);

  
  const fetchDownloads = async () => {
    try {
      setLoading(true);
      const result = await axiosBaseURL.get("/get-Downloads");
      const temp = EncryptDecrypt(result.data);
          if (showArchive) {
  setListDownloads(
    temp.data.filter((item) => item.is_archieve === true)
  );
} else {
  setListDownloads(
    temp.data.filter((item) => item.is_archieve === false)
  );
}
    } catch (error) {
      console.error("Error fetching downloads:", error);
      setListDownloads([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDownloads();
  }, [showArchive]);

  if (loading) {
    return <h6 className="loader">Loading......</h6>;
  }

  return (
    <>
      <InternalBaseBanner title={"List of Downloads"} />
      <BredCrumb title={"List of Downloads"} />

      <div className="common-bg">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-8">
              <div className="about-content">
                <h6>List of Downloads</h6>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <button
                className="btn btn-warning mb-3"
                onClick={() => setShowArchive(!showArchive)}
                aria-label={
                  showArchive
                    ? "Show last 12 months data"
                    : "Show archived downloads"
                }
              >
                {showArchive ? "Show last 12 months Data" : "Show Archive"}
              </button>

              <div className="table-responsive">
                <table className="table table-striped common-table bluetable">
                  <thead>
                    <tr>
                      <th scope="col">Sl. No.</th>
                      <th scope="col">Title</th>
                      <th scope="col">File</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listDownloads && listDownloads.length > 0 ? (
                      listDownloads.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>
                           <a
  href={item.file_path}
  target="_blank"
  rel="noopener noreferrer"
  aria-label={`Open file ${item.title} in new tab`}
>
  <i className="fas fa-file" aria-hidden="true"></i>
  <span className="sr-only">Download file</span>
</a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          <strong>No downloads found.</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Downloads;
